import React, { forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import _isString from 'lodash/isString';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import Styled from './styles';

/**
 *  CellTooltip is a custom cellRenderer component with ccfk styles for cell tooltip.
 */
const CellTooltip = forwardRef((props, ref) => getContext(({ theme }) => {
  const { getContent, theme: propTheme, ...otherProps } = props;
  const content = getContent(otherProps);
  const resolvedTheme = _merge({}, theme.TOOLTIP, propTheme);

  const containerProps = {
    $theme: resolvedTheme,
    isText: _isString(content),
    ...otherProps
  };

  // This is for style the wrapping div of this component managed by Ag-grid.
  props.reactContainer.style.position = 'absolute'; // eslint-disable-line no-param-reassign, react/prop-types

  useImperativeHandle(ref, () => ({
    getReactContainerClasses() {
      return ['csf-cell-tooltip'];
    }
  }));

  return (
    <Styled.TooltipTextContainer ref={ref} {...containerProps}>
      {content}
    </Styled.TooltipTextContainer>
  );
}));

CellTooltip.propTypes = {
  /** The content of the Tooltip. */
  getContent: PropTypes.func.isRequired,
  /** To override the theme. Please refer to the "Readme" tab to learn more. */
  theme: PropTypes.shape({})
};

CellTooltip.defaultProps = {
  theme: {}
};

CellTooltip.displayName = 'CellTooltip';

export default CellTooltip;